var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function(item) {
      return _c(
        "v-list",
        { key: item.id, staticClass: "purchased" },
        [
          _vm.isPast(item.pivot.created_at) && item.category != "merch"
            ? _c(
                "v-list-item",
                { class: item.pivot.paymentStatus },
                [
                  _c("v-list-item-content", [
                    _c("span", { staticClass: "credit" }, [
                      item.category == "pckg"
                        ? _c("span", [_vm._v(_vm._s(item.code))])
                        : _c("span", [_vm._v(_vm._s(item.pivot.notes))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "green--text" }, [
                        _vm._v("-$" + _vm._s(item.pivot.price))
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            new Date(item.pivot.created_at).toLocaleString(
                              "en-AU",
                              {
                                timeZone: "UTC",
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                              }
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            : !_vm.isPast(item.pivot.created_at)
            ? _c(
                "v-list-item",
                { class: item.pivot.paymentStatus },
                [
                  item.category === "merch"
                    ? _c("v-list-item-content", [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.pivot.notes) +
                              " " +
                              _vm._s(item.m_l) +
                              " " +
                              _vm._s(item.colour) +
                              " " +
                              _vm._s(item.size)
                          )
                        ]),
                        _vm._v("   "),
                        _c("strong", [
                          _vm._v("\n          $" + _vm._s(item.price))
                        ])
                      ])
                    : item.category === "tips"
                    ? _c("v-list-item-content", [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.name) + " " + _vm._s(item.pivot.notes)
                          )
                        ]),
                        _vm._v("   "),
                        _c("strong", [_vm._v(" $" + _vm._s(item.pivot.price))])
                      ])
                    : item.category === "split"
                    ? _c("v-list-item-content", [
                        _c("span", [_vm._v(_vm._s(item.pivot.notes))]),
                        _vm._v("   "),
                        _c("strong", [_vm._v(" $" + _vm._s(item.price))])
                      ])
                    : _c("v-list-item-content", [
                        _c("span", [_vm._v(_vm._s(item.pivot.notes))]),
                        _vm._v("   "),
                        _c("strong", [_vm._v(" $" + _vm._s(item.pivot.price))])
                      ]),
                  _vm._v(" "),
                  item.pivot.paymentStatus === "paid"
                    ? _c(
                        "v-list-item-avatar",
                        [
                          _vm.checkGate("void-transaction")
                            ? _c(
                                "v-avatar",
                                { attrs: { tile: "" } },
                                [
                                  item.category != "split" &&
                                  item.category != "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "red--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.voidItem(item)
                                            }
                                          }
                                        },
                                        [
                                          item.pivot.paymentMethod == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-refund")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-refund")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.category == "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "red--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.refund(item)
                                            }
                                          }
                                        },
                                        [
                                          item.pivot.paymentMethod == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-refund")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-refund")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : item.pivot.paymentStatus != "paid"
                    ? _c(
                        "v-list-item-avatar",
                        [
                          _vm.checkGate("void-transaction")
                            ? _c(
                                "v-avatar",
                                { attrs: { tile: "" } },
                                [
                                  item.category != "split" &&
                                  item.category != "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "green--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.undoVoidItem(item)
                                            }
                                          }
                                        },
                                        [
                                          item.pivot.paymentMethod == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-plus")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-plus")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.category == "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "green--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.undoRefund(item)
                                            }
                                          }
                                        },
                                        [
                                          item.pivot.paymentMethod == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-plus")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-plus")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }